// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"7":"component---src-pages-blog-js","532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] + "-" + {"7":"2a4b2042937513c5aefa","532":"0da30c4868f80da13552","678":"4541b512fc4f0540e152","682":"f4ba8ffdea818f0af631"}[chunkId] + ".js";
};